// 右上角"系统监控" widget 的紧急屏蔽开关。
//
// 运行时从 GET /api/v1/system/widget-config 拉一次,值由后端 HIDE_HEALTH_ERRORS
// 环境变量决定。镜像部署下 docker run -e HIDE_HEALTH_ERRORS=1 即可,不需要重新
// 构建前端。dashboard 真实异常判定不受影响。
//
// 加载完成前默认 false(不屏蔽),与历史行为一致;拉取失败也维持 false 兜底。

import { http } from '@blade/os-sdk';
import { create } from 'zustand';

interface WidgetConfigState {
  hideHealthErrors: boolean;
  loaded: boolean;
  load: () => Promise<void>;
}

interface WidgetConfigDto {
  hide_health_errors: boolean;
}

export const useWidgetConfigStore = create<WidgetConfigState>((set, get) => ({
  hideHealthErrors: false,
  loaded: false,
  load: async () => {
    if (get().loaded) return;
    try {
      const r = await http().get<WidgetConfigDto>('/system/widget-config');
      set({ hideHealthErrors: !!r.data.hide_health_errors, loaded: true });
    } catch {
      // 拉不到(网络/鉴权失败)就保持默认 false:维持原行为,不屏蔽
      set({ loaded: true });
    }
  },
}));

export const useHideHealthErrors = (): boolean =>
  useWidgetConfigStore((s) => s.hideHealthErrors);
